var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Divider',{staticStyle:{"color":"#fff"},attrs:{"dashed":""}},[_vm._v("租户分布")]),_c('div',{staticClass:"p-b-10"},[_c('h4',{staticClass:"workplatform-title m-t-10 m-b-20"},[_vm._v("一类业态分布")]),_c('div',[_c('Table',{attrs:{"stripe":"","size":"small","data":_vm.industryTypeData,"columns":_vm.typeColumns}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }